import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../login-service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {
rolesList:any;
addnewRole:boolean=false;
rolesListDetails:any;
pager: {
  totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
  endPage: number; startIndex: number; endIndex: number;
  pages: number[];
};
searchWord: string = "";
pagedItems: any;
SearchList:any;

currentpage: number=1;

searchText: any;

roleName:string;
data:any;
RoleDescription:string;
tempMenuList:any;
permissionsList = ['R', 'C', 'U', 'D'];
newPermissions={};
roleID:string;
dashboardMenuKeys = {R: false, C: false, U: false, D: false };
  locationMenuKeys = {R: false, C: false, U: false, D: false };
  categoryMenuKeys = {R: false, C: false, U: false, D: false };
  usersMenuKeys = {R: false, C: false, U: false, D: false };
  collabosMenuKeys = {R: false, C: false, U: false, D: false };
  plansMenuKeys = {R: false, C: false, U: false, D: false };
  emailsMenuKeys = {R: false, C: false, U: false, D: false };
  cmsMenuKeys = {R: false, C: false, U: false, D: false };
  skillsMenuKeys = {R: false, C: false, U: false, D: false };
  
  creteadminMenuKeys = {R: false, C: false, U: false, D: false };
  
  rolesMenuKeys = {R: false, C: false, U: false, D: false };
  
  menuData: any;
  checkedCB={};

  savePermissions={};
  dashboardMenuPermissions = {};
  locationMenuPermissions = {};
  categoryMenuPermissions = {};
  usersMenuPermissions = {};
  collabosMenuPermissions = {};
  plansMenuPermissions = {};
  emailsMenuPermissions = {};
  cmsMenuPermissions = {};
  userTypeid:string;

  createAdminMenuPermissions = {};
  RolesMenuPermissions = {};
  
roleNewID;any;
  PermissonJosn = {};
  errorMessage: string;
  tempRoleData: any;
  gruanualEdit: any;
  skillsMenuPermissions={};
  message: string;
  selectedrolesListid=[];
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p: number;
  count: number;
savefilter: any;
  constructor(private loginService:LoginService) { 
    this.roleNewID=localStorage.getItem("roleID");
    this.userTypeid=localStorage.getItem("userTypeid");
  }

  ngOnInit(): void {
    this.loginService.getselectpage(10)
    this.GetRoles();
    this.GetMenusByUserType(3);
  }

  GetMenusByUserType(userTypeID){
    this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
        {
    this.tempMenuList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
    let hideAdminRoles=this.tempMenuList.filter(x=>x.menu_name!=='Create Admin' &&x.menu_name!=='Roles');
  
    if(hideAdminRoles.length>0)
    {
      this.menuData=hideAdminRoles;
    }
    
    
        });
        }
        changepagination(page:number){
          this.count=this.rowsOnPage
          console.log(this.rowsOnPage)
          this.loginService.getselectpage(this.rowsOnPage)
          this.loginService.getPager(this.rolesListDetails.length, page);
          this.setPage(page)
        }

        setPage(page: number) {

   this.p=page
          this.pager = this.loginService.getPager(this.rolesListDetails.length, page);
          this.count=this.pager.pageSize
          this.pagedItems = this.rolesListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
          this.rolesList = this.rolesListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
        
      }
      
      Searchtext(){
          this.rolesList = this.savefilter;
        
              let tempCompany = this.rolesList.filter(
                (item) => {
                  return (
                    (item.RoleName !== null && item.RoleName.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
                    (item.RoleDescription !== null && item.RoleDescription.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
                    
                  );
                }
          
              );
              this.assigndynamicarray(tempCompany)
              this.rolesList = tempCompany;
              // if(this.searchText==""){
              //   this.GetRoles();
              //   this.assigndynamicarray(this.rolesList)
              // }
              if(this.searchText !== ""){
                this.rolesListDetails = tempCompany;
                this.setPage(1);
            }else{
                this.rolesListDetails = this.savefilter;      
                this.assigndynamicarray(this.rolesList)
          
                this.setPage(1);
            }
        }

  NewROle(){
this.addnewRole=true;
this.data="new";
  }
  CancelRole(){
    this.addnewRole=false;
  }

  selectRow(id,e){
    if(e.target.checked){
     this.selectedrolesListid.push(e.target.id)
    }
    else{
     var index = this.selectedrolesListid.indexOf(e.target.id);
    this.selectedrolesListid.splice(index,1)
    }
  }
  DeleteSelected(){
   if(this.selectedrolesListid.length==0){
     return;
   }
   else{
     event.stopPropagation();
     Swal.fire({
       title: 'Are you sure?',
       text: 'You want to delete the selected rows' ,///
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Yes',
       cancelButtonText: 'No'
     }).then((result) => {
       if (result.value) {
         this.deleterows(this.selectedrolesListid);//
       } else if (result.dismiss === Swal.DismissReason.cancel) {
   
       }
     })
   }
  }
  deleterows(list){
 for(var i=0;i<list.length;i++){
   this.delete(list[i],'d');
   this.selectedrolesListid=[];
 }
  }

   deleteRoles(row,isactive,text){
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to '+text+' this roles:' + row.city,///
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.delete(row.RoleID,isactive);//
      } else if (result.dismiss === Swal.DismissReason.cancel) {
  
      }
    })
  
  }
  
  delete(ID,isactive) {
    const json={
      RoleID:ID,
      isactive:isactive
    }
    this.loginService.DeleteRoles(json).subscribe(data => {
   if(isactive=='d'){
    this.loginService.showSuccess("Deleted Successfully","");
  
  }
  else if(isactive=='y'){
  this.loginService.showSuccess("Activated Successfully","");
  
  }
  else{
  this.loginService.showSuccess("Deactivated Successfully","");
  
  }
      this.GetRoles();
      setTimeout(() => {
        this.message = "";
      }, 1000);
    // this.getFares();
    // this.setPage(1);
    })
  }
  
GetRoles(){
this.loginService.GetRoles(this.userTypeid).subscribe(data=>{
  
  // data = JSON.parse(data['_body']);
  this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])))
  this.rolesListDetails=this.rolesList;
  this.savefilter=this.rolesListDetails
this.tempRoleData=this.rolesList.filter(x=>x.RoleID==this.roleNewID);
this.assigndynamicarray(this.rolesList)
if(this.rolesList.length>0){
  this.setPage(1);
}
if(this.tempRoleData.length>0)
  this.newPermissions = JSON.parse( this.tempRoleData[0].MenuJson);
   
  let menusList = Object.keys(this.newPermissions);
  for(let i=0;i<menusList.length;i++){
    let menuIds = Object.keys(this.newPermissions[menusList[i]]);
    let subLevel = this.newPermissions[menusList[i]];
    for(let j=0;j<menuIds.length;j++){
  
      this.newPermissions[menusList[i]][menuIds[j]]['R'] = false;
      this.newPermissions[menusList[i]][menuIds[j]]['C'] = false;
      this.newPermissions[menusList[i]][menuIds[j]]['U'] = false;
      this.newPermissions[menusList[i]][menuIds[j]]['D'] = false;

     
    }}
})

}
assigndynamicarray(userslist)
{
  this.dynamicRows=10
  this.rowsOnPageSet=[];
  this.rowCount = userslist.length;
  console.log(this.rowCount,this.dynamicRows)
  while (this.dynamicRows < this.rowCount) {
    this.rowsOnPageSet.push(this.dynamicRows);
    this.dynamicRows = this.dynamicRows + 10;
    console.log(this.rowsOnPageSet)
  }
  if (!this.rowsOnPageSet.includes(this.rowCount))
    this.rowsOnPageSet.push(this.rowCount);
  if (this.rowsOnPageSet.length === 1) {
    if (this.rowsOnPageSet[0] <= 10)
      this.rowsOnPage = this.rowsOnPageSet[0];
  }
  this.rowsOnPage = this.rowsOnPageSet[0];
}

onCheckboxMenuChange(MapType, key , permissonType, event,type) {
if(permissonType=='C'){
this.checkedCB['C']=false;
}
if(permissonType=='U'){
this.checkedCB['U']=false;
}
if(permissonType=='D'){
this.checkedCB['D']=false;
}
  if (MapType === 'Dashboard') {  
    this.dashboardMenuKeys[permissonType] = event.checked;
    this.dashboardMenuPermissions[key] = this.dashboardMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
  
      this.dashboardMenuKeys['R'] = true;
     }
    if(permissonType == 'R' && !event.checked){
      this.dashboardMenuKeys['C'] = false;
      this.dashboardMenuKeys['U'] = false;
      this.dashboardMenuKeys['D'] = false;      
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;        
     }
   
    if(type == 'edit'){
    this.PermissonJosn['Dashboard'] = this.dashboardMenuPermissions;
  }else{
    
    this.newPermissions[MapType] = this.dashboardMenuPermissions; 
}
  } else if (MapType === 'Location') {
    this.locationMenuKeys[permissonType] = event.checked;
    this.locationMenuPermissions[key] = this.locationMenuKeys; 
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){       
      this.locationMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.locationMenuKeys['C'] = false;
      this.locationMenuKeys['U'] = false;
      this.locationMenuKeys['D'] = false;
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;            
     }     
    if(type == 'edit'){
      this.PermissonJosn['Location'] = this.locationMenuPermissions;
    }else{
     
    

      this.newPermissions[MapType] = this.locationMenuPermissions; 
}
  } else if (MapType === 'Category') {
    this.categoryMenuKeys[permissonType] = event.checked;
    this.categoryMenuPermissions[key] = this.categoryMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
      
      this.categoryMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.categoryMenuKeys['C'] = false;
      this.categoryMenuKeys['U'] = false;
      this.categoryMenuKeys['D'] = false;
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;             
     }
    if(type == 'edit'){
      this.PermissonJosn['Category'] = this.categoryMenuPermissions;
    }else{
    
     

      this.newPermissions[MapType] = this.categoryMenuPermissions; 
}
  } else if (MapType === 'Users') {
    this.usersMenuKeys[permissonType] = event.checked;
    this.usersMenuPermissions[key] = this.usersMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
     
      this.usersMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.usersMenuKeys['C'] = false;
      this.usersMenuKeys['U'] = false;
      this.usersMenuKeys['D'] = false;
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;            
     }
    if(type == 'edit'){
      this.PermissonJosn['Users'] = this.usersMenuPermissions;
    }else{
      
   

      this.newPermissions[MapType] = this.usersMenuPermissions; 
}
  }else if (MapType === 'Collabos') {
    this.collabosMenuKeys[permissonType] = event.checked;
    this.collabosMenuPermissions[key] = this.collabosMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
      
      this.collabosMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.collabosMenuKeys['C'] = false;
      this.collabosMenuKeys['U'] = false;
      this.collabosMenuKeys['D'] = false;
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;             
     }
    if(type == 'edit'){
      this.PermissonJosn['Collabos'] = this.collabosMenuPermissions;
    }else{
     
     

      this.newPermissions[MapType] = this.collabosMenuPermissions; 
}
  } else if (MapType === 'Plans') {
    this.plansMenuKeys[permissonType] = event.checked;
    this.plansMenuPermissions[key] = this.plansMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
     
      this.plansMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.plansMenuKeys['C'] = false;
      this.plansMenuKeys['U'] = false;
      this.plansMenuKeys['D'] = false;
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;             
     }
    if(type == 'edit'){
      this.PermissonJosn['Plans'] = this.plansMenuPermissions;
    }else{
     
     

      this.newPermissions[MapType] = this.plansMenuPermissions; 
}
  } 
  else if (MapType === 'Emails') {
    this.emailsMenuKeys[permissonType] = event.checked;
    this.emailsMenuPermissions[key] = this.emailsMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
     
      this.emailsMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.emailsMenuKeys['C'] = false;
      this.emailsMenuKeys['U'] = false;
      this.emailsMenuKeys['D'] = false;  
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;           
     }
    if(type == 'edit'){
      this.PermissonJosn['Emails'] = this.emailsMenuPermissions;
    }else{
     
     

      this.newPermissions[MapType] = this.emailsMenuPermissions; 
}
  }
  else if (MapType === 'CMS') {

    this.cmsMenuKeys[permissonType] = event.checked;
    this.cmsMenuPermissions[key] = this.cmsMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
      
      this.cmsMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.cmsMenuKeys['C'] = false;
      this.cmsMenuKeys['U'] = false;
      this.cmsMenuKeys['D'] = false;
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;             
     }

    if(type == 'edit'){
      this.PermissonJosn['CMS'] = this.cmsMenuPermissions;
    }else{
     
      this.newPermissions[MapType] = this.cmsMenuPermissions; 
}
  }
  else if (MapType === 'Skills') {
    this.skillsMenuKeys[permissonType] = event.checked;
    this.skillsMenuPermissions[key] = this.skillsMenuKeys;
    if(permissonType == 'C' || permissonType == 'U' || permissonType == 'D'){
     
      this.skillsMenuKeys['R'] = true;
     }
     if(permissonType == 'R' && !event.checked){
      this.skillsMenuKeys['C'] = false;
      this.skillsMenuKeys['U'] = false;
      this.skillsMenuKeys['D'] = false;  
      this.checkedCB['R']=false;
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;           
     }
    if(type == 'edit'){
      this.PermissonJosn['Skills'] = this.skillsMenuPermissions;
    }else{
     
     

      this.newPermissions[MapType] = this.skillsMenuPermissions; 
}
  }
}
onClick(list, data)
{

  if(list=='R' )
  {
    for(let i=0; i<this.menuData.length; i++){
     
     if(data==='edit'&& this.checkedCB['R']==true){
      this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
     }else if(data==='new'&& this.checkedCB['R']==true){
      
     
      this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      
     }else if(data==='new'&& this.checkedCB['R']==false){
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;
      this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=false;
      this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['C']=false;
      this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['U']=false;
      this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['D']=false;
     }else if(data==='edit'&& this.checkedCB['R']==false){
      this.checkedCB['C']=false;
      this.checkedCB['U']=false;
      this.checkedCB['D']=false;
      this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=false;
      this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['C']=false;
      this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['U']=false;
      this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['D']=false;
     
     }
      
    }
   
  }
  if(list==='C')
  {
    for(let i=0; i<this.menuData.length; i++){
      
      // && (this.menuData[i].menu_name!=='ProcessMap' || list=='C' )
      // if((this.menuData[i].menu_name!=='Dashboard'  || list=='R') && (this.menuData[i].menu_name!=='Location' || list=='R') && (this.menuData[i].menu_name!='Category' || list=='R') && (this.menuData[i].menu_name!=='Users' || list=='R' || list=='U' ) && (this.menuData[i].menu_name !== 'Collabos' || list=='R') && (this.menuData[i].menu_name !=='Plans' || list=='R' ) && (this.menuData[i].menu_name !=='Emails' || list=='R' )&& (this.menuData[i].menu_name !=='CMS' || list=='R' ))
      if(data==='edit'&& this.checkedCB['C']==true){
       this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['C']=true;
       this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      }else if(data==='new'&& this.checkedCB['C']==true){
       this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['C']=true;
       this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      }else if(data==='new'&& this.checkedCB['C']==false){
        this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['C']=false;
       }else if(data==='edit'&& this.checkedCB['C']==false){
        this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['C']=false;
       }
      
    }
  }
  if(list==='U')
  {
    for(let i=0; i<this.menuData.length; i++){
      // && (this.menuData[i].menu_name!=='ProcessMap' || list=='C' )
      // if((this.menuData[i].menu_name!=='Dashboard'  || list=='R') && (this.menuData[i].menu_name!=='Location' || list=='R') && (this.menuData[i].menu_name!='Category' || list=='R') && (this.menuData[i].menu_name!=='Users' || list=='R' || list=='U' ) && (this.menuData[i].menu_name !== 'Collabos' || list=='R') && (this.menuData[i].menu_name !=='Plans' || list=='R' ) && (this.menuData[i].menu_name !=='Emails' || list=='R' )&& (this.menuData[i].menu_name !=='CMS' || list=='R' ))
      if(data==='edit'&& this.checkedCB['U']==true){
       this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['U']=true;
       this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      }else if(data==='new'&& this.checkedCB['U']==true){
       this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['U']=true;
       this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      }else if(data==='new'&& this.checkedCB['U']==false){
        this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['U']=false;
       }else if(data==='edit'&& this.checkedCB['U']==false){
        this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['U']=false;
       }
    }
  }
  if(list==='D')
  {
    for(let i=0; i<this.menuData.length; i++){
      // && (this.menuData[i].menu_name!=='ProcessMap' || list=='C' ) 
      // if((this.menuData[i].menu_name!=='Dashboard'  || list=='R') && (this.menuData[i].menu_name!=='Location' || list=='R') && (this.menuData[i].menu_name!='Category' || list=='R') && (this.menuData[i].menu_name!=='Users' || list=='R' || list=='U' ) && (this.menuData[i].menu_name !== 'Collabos' || list=='R') && (this.menuData[i].menu_name !=='Plans' || list=='R' ) && (this.menuData[i].menu_name !=='Emails' || list=='R' )&& (this.menuData[i].menu_name !=='CMS' || list=='R' ))
      if(data==='edit'&& this.checkedCB['D']==true){
       this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['D']=true;
       this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      }else if(data==='new'&& this.checkedCB['D']==true){
       this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['D']=true;
       this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['R']=true;
      }else if(data==='new'&& this.checkedCB['D']==false){
        this.newPermissions[this.menuData[i].menu_name][this.menuData[i].menu_id]['D']=false;
       }else if(data==='edit'&& this.checkedCB['D']==false){
        this.PermissonJosn[this.menuData[i].menu_name][this.menuData[i].menu_id]['D']=false;
       }
    }
  }
}
AddRole() {
    
    if(this.roleName === undefined|| this.roleName.trim() === '' ){
      this.errorMessage = "Please enter mandatory(*) fields";
      return;
    }else{
      
// let savePermissions = {};
// let granualPermission = {};
let roleID = "";

if(!this.roleID){
 
  this.savePermissions= this.newPermissions;
  
  roleID = "";
}else {
  
  this.savePermissions=this.PermissonJosn;
  
}
   
   
      let josn = {
        RoleName: this.roleName,
        RoleDescription: this.RoleDescription,
        
        
        MenuJson:this.savePermissions,
        CreatedBy:'SuperAdmin',
        RoleId: roleID,
       
      }
  
        this.loginService.SaveRole(josn).subscribe(permisn => {
  
          if (permisn['_body'].toString() === 'true') {
            this.loginService.showSuccess("Role Save Successfully..!", "");
        
           // this.dialogRef.close(true);
          } else {
            this.loginService.showSuccess("Role Updated Successfully..!", "");
        
          // this.dataSelf = 'Updated successfully';
          }
        });
    }
    

  }
  EditRole(element){
    this.addnewRole=true;
    this.roleName = element.RoleName;
    this.RoleDescription = element.RoleDescription;
    this.roleID = element.RoleID;
   
    this.PermissonJosn = JSON.parse(element.MenuJson);

    this.dashboardMenuKeys = this.PermissonJosn['Dashboard']['22'];
    this.locationMenuKeys = this.PermissonJosn['Location']['23'];
    this.categoryMenuKeys = this.PermissonJosn['Category']['24'];
    this.skillsMenuKeys  = this.PermissonJosn['Skills']['25'];
    this.usersMenuKeys  = this.PermissonJosn['Users']['26'];
    this.collabosMenuKeys = this.PermissonJosn['Collabos']['27'];
    this.plansMenuKeys = this.PermissonJosn['Plans']['28'];
    this.emailsMenuKeys = this.PermissonJosn['Emails']['29'];
    this.cmsMenuKeys = this.PermissonJosn['CMS']['30'];
    this.savePermissions=this.PermissonJosn;

  }

}
